export default __webpack_public_path__ + "static/media/LosAngeles.eab7818e.webp";